export const LIST_COMMODATE_LOAN = 'LIST_COMMODATE_LOAN';
export const MESSAGE = 'MESSAGE';
export const FETCH_DATA = 'FETCH_DATA';
export const GET_COMMODATE = 'GET_COMMODATE';
export const GET_BORROWER_LIST = 'GET_BORROWER_LIST';